/**
 * CHIKAS coverflow — slides already in DOM (Shopify Liquid), autoplay via data-interval
 */
(function () {
  function wrap(i, len) {
    return ((i % len) + len) % len;
  }

  function relativePos(slideIndex, active, len) {
    let d = slideIndex - active;
    if (d > len / 2) d -= len;
    if (d < -len / 2) d += len;
    if (d === -1 || d === 0 || d === 1 || d === -2 || d === 2) return String(d);
    return 'hidden';
  }

  function mount(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    const track = root.querySelector('[data-story-track]');
    const dotsWrap = root.querySelector('[data-story-dots]');
    const prev = root.querySelector('[data-story-prev]');
    const next = root.querySelector('[data-story-next]');
    if (!track) return;

    const slides = [...track.querySelectorAll('[data-story-slide]')];
    if (!slides.length) return;

    const INTERVAL = Math.max(3000, Number(root.dataset.interval) || 5000);

    if (dotsWrap) {
      dotsWrap.innerHTML = slides
        .map(
          (s, i) =>
            `<button type="button" data-story-dot role="tab" aria-label="${
              s.getAttribute('aria-label') || 'Historia ' + (i + 1)
            }" class="${i === 0 ? 'is-active' : ''}"></button>`
        )
        .join('');
    }

    const dots = [...(dotsWrap?.querySelectorAll('[data-story-dot]') || [])];
    let index = 0;
    let timer = null;
    let animating = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint() {
      slides.forEach((slide, i) => {
        const pos = relativePos(i, index, slides.length);
        slide.dataset.pos = pos;
        if (pos === '0') slide.setAttribute('aria-current', 'true');
        else slide.removeAttribute('aria-current');
        slide.tabIndex = pos === '-1' || pos === '1' ? 0 : -1;
      });
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }

    function go(i) {
      if (animating) return;
      animating = true;
      index = wrap(i, slides.length);
      paint();
      window.setTimeout(() => {
        animating = false;
      }, reduced ? 0 : 750);
      restart();
    }

    function restart() {
      if (timer) window.clearInterval(timer);
      if (reduced) return;
      timer = window.setInterval(() => go(index + 1), INTERVAL);
    }

    slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        const i = Number(slide.dataset.index);
        if (Number.isNaN(i) || i === index) return;
        go(i);
      });
    });
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));

    root.addEventListener('mouseenter', () => {
      if (timer) window.clearInterval(timer);
    });
    root.addEventListener('mouseleave', restart);

    let startX = null;
    track.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
    }, { passive: true });
    track.addEventListener('pointerup', (e) => {
      if (startX == null) return;
      const dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      go(index + (dx < 0 ? 1 : -1));
    });

    paint();
    restart();
  }

  function boot() {
    document.querySelectorAll('[data-chikas-stories]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
